<template>
  <ul class="text_quiz__answers">
    <li class="text_quiz__answer" v-for="item in answers">
      <label>
        <input type="radio" class="uk-radio" :name="keys" @change="checkAnswer(item)">
        <span>{{ item.answer }}</span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  name: "answers",
  data() {
    return {
      answers: ''
    }
  },
  props: {
    items: '',
    answer: '',
    keys: ''
  },
  methods: {
    makeAnswers() {
      let answers = [];
      answers.push({
        'answer': this.answer,
        'status': true
      });
      _.forEach(this.items, (i) => {
        answers.push({
          'answer': i.answer,
          'status': false
        });
      });

      this.answers = _.shuffle(answers);

    },
    checkAnswer(item){
      console.log(item);
      this.$emit('selectAnswer', item);
    }
  },
  mounted() {
    this.makeAnswers();
  }
}
</script>